<template>
  <div class="actions-message-new">
    <el-tooltip
      :content="$t('campaign.messages.new.ai-message-tooltip')"
      placement="top"
      popper-class="actions-message-new__tooltip"
    >
      <ai-button
        v-show="getEnableOtomatico"
        :label="$t('campaign.messages.new.ai-message')"
        :link="whatsAppLink"
        @on-click="handleCreateAiMessageLink"
      />
    </el-tooltip>

    <button class="btn" @click="openModal" data-cy="btn-new-message">
      {{ $t('campaign.messages.new.message') }}
    </button>
  </div>
</template>

<script>
// libs, helpers
import i18n from '@/i18n';
import { mapGetters } from 'vuex';
import bus from '@/helpers/events/bus';
import AiButton from '@/components/_atoms/AIButton.vue';
import { otoBotWhatsAppNumber } from '@/utilities/constants';
import { useMixpanelConfig } from '@/utilities/mixpanel';

export default {
  name: 'ActionsMessageHeaderNew',
  components: {
    AiButton,
  },
  computed: {
    ...mapGetters(['getEnableOtomatico']),
    whatsAppLink() {
      const initialMessage = i18n.global.t('campaign.messages.new.ai-whatsapp-message');
      return `https://api.whatsapp.com/send/?phone=${otoBotWhatsAppNumber}&text=${initialMessage}&type=phone_number&app_absent=1`;
    },
  },
  methods: {
    openModal() {
      bus.$emit('open-actions-new-message-modal');
    },
    handleCreateAiMessageLink() {
      useMixpanelConfig('create_ai_message');
    },
  },
};
</script>

<style lang="scss" scoped>
.actions-message-new {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-right: 30px;
  width: 100%;

  .btn {
    height: 36px;
    line-height: 20px;
    width: 194px;
    padding: 0 15px;

    .icon {
      font-weight: bold;
    }
  }
}
</style>

<style lang="scss">
.el-popper.is-dark.actions-message-new__tooltip {
  width: 284px;
  padding: 10px 16px;
  border-radius: 8px;
  background-color: $color-white !important;
  border: 1px solid $purple-400 !important;
  color: $purple-400;
}

.el-popper.is-dark.actions-message-new__tooltip .el-popper__arrow::before {
  background: $color-white !important;
  border: 1px solid;
}
</style>
